import {
  GET_LIMITED_ANNOUNCEMENT_REQUEST,
  GET_LIMITED_ANNOUNCEMENT_SUCCESS,
  GET_LIMITED_ANNOUNCEMENT_FAIL,
} from "../../types/admin/limitedAnnouncementTypes";

export const limitedAnnouncementReducer = (
  state = { notifications: [] },
  action
) => {
  switch (action.type) {
    case GET_LIMITED_ANNOUNCEMENT_REQUEST:
      return { loading: true, notifications: [] };

    case GET_LIMITED_ANNOUNCEMENT_SUCCESS:
      return { loading: false, notifications: action.payload };

    case GET_LIMITED_ANNOUNCEMENT_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
